<div class="estimate-question-details">
	@for (question of estimateQuestions(); track question.questionId) {
		<div class="estimate-question">
			@if (question.type === LONG_OPTION_SINGLE_CHOICE) {
				<long-option-single-choice-details
					[question]="question"
					[standard]="product.standard.name"
					[changeSet]="changeSet"
					[translateClientsData]="translateClientsData"
					[useOriginalTranslations]="useOriginalTranslations"
					[accreditationBody]="product.accreditationBody">
				</long-option-single-choice-details>
			}
		</div>
	}
</div>
